// src/pages/WritePost/index.jsx
import React from 'react';
import { Card, Form, Input, Select, Button, message, Typography } from 'antd';
import AppFooter from '../../components/Footer'; 
import AppHeader from '../../components/Header';
import { useUser } from '../../utils/userContext.js';
import { useNavigate } from 'react-router-dom';
import './index.css';

const { Title } = Typography;

const WritePost = () => {
  const { user } = useUser();
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const onFinish = (values) => {
    // 生成文章ID
    const newArticle = {
      id: Date.now(), // 使用时间戳作为唯一ID
      title: values.title,
      abstract: values.summary,
      content: values.content,
      tags: values.tags || [],
      date: new Date().toISOString().split('T')[0], // 格式化为 YYYY-MM-DD
      author: user ? user.username : 'Anonymous'
    };

    // 从localStorage获取现有文章
    const existingArticles = JSON.parse(localStorage.getItem('articles')) || [];
    
    // 添加新文章
    const updatedArticles = [newArticle, ...existingArticles];
    
    // 保存到localStorage
    localStorage.setItem('articles', JSON.stringify(updatedArticles));
    
    message.success('文章发布成功！');
    
    // 重置表单
    form.resetFields();
    
    // 跳转到归档页面
    setTimeout(() => {
      navigate('/archive');
    }, 1000);
  };

  return (
    <div className="write-post-container">
      <AppHeader />
      
      <Card 
        className="write-post-card"
        style={{ margin: '40px auto', maxWidth: '800px', width: '90%' }}
      >
        <Title level={2} style={{ textAlign: 'center', marginBottom: 24 }}>
          撰写新文章
        </Title>
        
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
        >
          <Form.Item
            label="文章标题"
            name="title"
            rules={[{ required: true, message: '请输入文章标题！' }]}
          >
            <Input 
              placeholder="请输入文章标题" 
              size="large" 
            />
          </Form.Item>

          <Form.Item
            label="文章摘要"
            name="summary"
            rules={[{ required: true, message: '请输入文章摘要！' }]}
          >
            <Input.TextArea 
              placeholder="请输入文章摘要,不超过200字" 
              rows={4} 
              maxLength={200}
              showCount
            />
          </Form.Item>

          <Form.Item
            label="标签"
            name="tags"
          >
            <Select
              mode="tags" 
              style={{ width: '100%' }}
              placeholder="选择或输入标签 (按回车键创建新标签)"
              tokenSeparators={[',']}
            >
            </Select>
          </Form.Item>

          <Form.Item
            label="文章内容（支持Markdown语法）"
            name="content"
            rules={[{ required: true, message: '请输入文章内容！' }]}
          >
            <Input.TextArea 
              placeholder="请使用Markdown格式输入文章内容" 
              rows={10}
            />
          </Form.Item>

          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              size="large"
              style={{ width: '100%' }}
            >
              发布文章
            </Button>
          </Form.Item>
        </Form>
      </Card>
      
      <AppFooter />
    </div>
  );
};

export default WritePost;